import { InjectionToken } from '@angular/core';

export const WINDOW_REF = new InjectionToken<Window>('Window reference');
